<div class="menu-wrapper">
  @for (item of items; track $index) {
    <button mat-menu-item
            (click)="setFilter(item)"
    >
      {{ item.name }}
    </button>
  }

  <div class="menu-footer">
    <mat-divider></mat-divider>

    <div class="menu-footer-actions">
      <button
        mat-button
        color="accent"
        (click)="setFilter(null)">
        Clear
      </button>
    </div>
  </div>
</div>

